// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H5TP","icon":"styles_icon__6rufr"};